import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlPrefix } from '../../../../shared-module/common/constants/url-prefix.constants';
import { SystemCertificateTableRow } from '../../certificate-management.model';
import { IPagedDataTable } from '../../../../shared-module/common/interfaces/IPagedDataTable.interface';
import { DataTableFilter } from '../../../../shared-module/common/models/DataTableFilter.model';
import { IDataTableService } from '../../../../shared-module/common/interfaces/IDataTableService.interface';


@Injectable()
export class SystemCertificatesDataTableService implements IDataTableService<SystemCertificateTableRow> {
  constructor(private http: HttpClient) {
  }
  public getRows(filter: DataTableFilter): Observable<IPagedDataTable<SystemCertificateTableRow>> {
    return this.http.get<IPagedDataTable<SystemCertificateTableRow>>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/certificateManagement?${filter.toQueryString()}`);
  }

  public delete(id: number): Observable<void> {
    return this.http.delete<void>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/certificateManagement/${id}`);
  }
}
